import client from './client';

export const listWaterSources = (params) =>
  client.get('/water-sources', { params }).then((r) => r.data);

export const listWaterSourcesForMap = (tenantId) =>
  client.get('/water-sources/map', { params: { tenant_id: tenantId } }).then((r) => r.data);

export const getWaterSource = (id) =>
  client.get(`/water-sources/${id}`).then((r) => r.data);

export const createWaterSource = (data) =>
  client.post('/water-sources', data).then((r) => r.data);

export const updateWaterSource = (id, data) =>
  client.patch(`/water-sources/${id}`, data).then((r) => r.data);

export const inspectWaterSource = (id, data) =>
  client.post(`/water-sources/${id}/inspect`, data).then((r) => r.data);

export const deleteWaterSource = (id) =>
  client.delete(`/water-sources/${id}`).then((r) => r.data);

export const uploadWaterSourcePhoto = (id, file) => {
  const form = new FormData();
  form.append('file', file);
  return client.post(`/water-sources/${id}/photo`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((r) => r.data);
};
